import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { Check } from "lucide-react"
import { cn } from "@/utils/tailwind-util"

const Checkbox = React.forwardRef<
  React.ComponentRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === "Enter") {
      e.preventDefault()
      e.currentTarget.click()
    } else if (e.key === "ArrowDown" || e.key === "ArrowRight") {
      e.preventDefault()
      const allCheckboxes = Array.from(document.querySelectorAll('button[role="checkbox"], input[type="checkbox"]')) as HTMLElement[]
      const index = allCheckboxes.indexOf(e.currentTarget)
      if (index > -1 && index < allCheckboxes.length - 1) {
        allCheckboxes[index + 1].focus()
      }
    } else if (e.key === "ArrowUp" || e.key === "ArrowLeft") {
      e.preventDefault()
      const allCheckboxes = Array.from(document.querySelectorAll('button[role="checkbox"], input[type="checkbox"]')) as HTMLElement[]
      const index = allCheckboxes.indexOf(e.currentTarget)
      if (index > 0) {
        allCheckboxes[index - 1].focus()
      }
    }
    props.onKeyDown?.(e)
  }

  return (
    <CheckboxPrimitive.Root
      ref={ref}
      className={cn(
        "peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground hover:cursor-pointer transition-all duration-200 active:scale-90",
        className
      )}
      onKeyDown={handleKeyDown}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        className={cn("flex items-center justify-center text-current")}
      >
        <Check className="h-4 w-4" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
})
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
